import React from 'react';
import PageWrapper from '../components/PageWrapper';
import { useAuthEffects } from '../components/Auth';
import { Divider, Grid2, Box, Typography, ImageList, useMediaQuery, useTheme, Button } from '@mui/material';
import { usePlansListPublicQuery, useRemoveFavouriteMutation } from '../services/plans';
import {PlanListItemEl} from '../components/PlanList';
import { useShippingRegionContext } from '../contexts/ShippingRegionContext';
import { useFavourites } from '../contexts/FavouritesContext';
import { Link as RouterLink } from 'react-router-dom';
import FavoriteIcon from '@mui/icons-material/FavoriteBorder';

const DiscoverView = () => {
	useAuthEffects();
	const [removeFavouriteMutation] = useRemoveFavouriteMutation();
	const { favouriteIds } = useFavourites();
	const theme = useTheme();
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
	const isXsUp = useMediaQuery(theme.breakpoints.up('sm'));

	const {selectedRegion} = useShippingRegionContext();
	const {data: listItems = []} = usePlansListPublicQuery({tags: [], countryCode: selectedRegion as string, where: {id: {
		operator: 'in',
		values: Array.from(favouriteIds)
	}}}, {skip: !selectedRegion});

	const handleRemoveFavouriteBtnClick = (planId: number) => {
		removeFavouriteMutation(planId);
	};

	return <PageWrapper disableFooter={!listItems.length} noScroll={!listItems.length}>
		{!listItems.length ? <Box flex={1} display='flex' alignItems='center' justifyContent='center' flexDirection='column' gap={3}>
			<Typography fontSize='1.2rem' textAlign='center'>Save projects to your favourites by clicking the <FavoriteIcon sx={{mb: -0.5}} /> icon!</Typography>
			<Button component={RouterLink} variant='contained' size='large' to='/'>Browse projects</Button>
		</Box> :
			<Grid2 container spacing={8}>
				<Grid2 size={12}>
					<Divider sx={{mt: 1}}/>
					<ImageList gap={8} cols={isMdUp ? 3 : isXsUp ? 2 : 1} rowHeight={400}>
						{listItems.map((item) => <PlanListItemEl 
							key={item.id}
							item={item}
							isFavourited
							onRemoveFavouriteBtnClick={() => handleRemoveFavouriteBtnClick(item.id)}
						/>)}
					</ImageList>
				</Grid2>
			</Grid2>}
	</PageWrapper>;
};

export default DiscoverView;
